import { Link } from 'react-router-dom'
import { motion } from 'motion/react'
import { ArrowRight, Phone, Calendar } from 'lucide-react'
import { Button } from '@/components/ui'
import { companyInfo } from '@/data/company'

const CALENDAR_LINK = 'https://meetings.hubspot.com/markus98/ucadvisors-quick-chat?embed=true&uuid=052b5298-7c6e-4b12-bde4-f8f26d01c9b3'

export function CTASection() {
  return (
    <section className="section-padding relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-accent-500/10 via-primary-500 to-electric-500/10" />
      
      {/* Animated background elements */}
      <motion.div
        className="absolute top-0 left-1/4 w-64 h-64 bg-accent-500/10 rounded-full blur-3xl"
        animate={{
          y: [0, 30, 0],
          scale: [1, 1.1, 1],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
      <motion.div
        className="absolute bottom-0 right-1/4 w-48 h-48 bg-electric-500/10 rounded-full blur-3xl"
        animate={{
          y: [0, -20, 0],
          scale: [1.1, 1, 1.1],
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />

      <div className="container-custom relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="glass-card rounded-3xl p-8 md:p-12 lg:p-16 text-center"
        >
          <h2 className="text-display-sm md:text-display-md lg:text-display-lg font-heading font-bold text-white mb-6">
            Ready to Transform Your Business?
          </h2>
          <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto mb-10">
            Book a quick call with our team. We'll discuss your needs and show you how we can help — no sales pitch, just answers.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href={CALENDAR_LINK} target="_blank" rel="noopener noreferrer">
              <Button size="xl" variant="glow" className="group">
                <Calendar className="w-5 h-5 mr-2" />
                Book a 15-min Call
                <ArrowRight className="w-5 h-5 ml-1 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
            <a href={`tel:${companyInfo.phoneRaw}`}>
              <Button size="xl" variant="secondary">
                <Phone className="w-5 h-5" />
                {companyInfo.phone}
              </Button>
            </a>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-slate-400">
            <span>No commitment required.</span>
            <span className="hidden sm:inline">•</span>
            <Link to="/contact" className="text-accent-400 hover:text-accent-300 transition-colors">
              Or request a detailed quote →
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  )
}


